import MissingSlugVariableError from "../../errors/MissingSlugVariableError";
import normalizeTaxon from "../../utils/normalizations/normalize-taxon";
export default function getTaxonOperation({ commerce  }) {
    async function getTaxon({ query ="" , variables: getTaxonVariables , config: userConfig  }) {
        //Uncomment the following line to debug
        /* console.log(
      'getTaxon called. Configuration: ',
      'getTaxonVariables: ',
      getTaxonVariables,
      'config: ',
      userConfig
    ) */ if (!(getTaxonVariables == null ? void 0 : getTaxonVariables.slug)) {
            throw new MissingSlugVariableError();
        }
        const variables = {
            methodPath: "taxons.show",
            arguments: [
                getTaxonVariables.slug,
                {
                    include: "taxonomy,children,image,parent,parent.children"
                }, 
            ]
        };
        const config = commerce.getConfig(userConfig);
        const { fetch: apiFetch  } = config // TODO: Send config.locale to Spree.
        ;
        const { data: spreeSuccessResponse  } = await apiFetch("__UNUSED__", {
            variables
        });
        return {
            taxon: normalizeTaxon(spreeSuccessResponse, spreeSuccessResponse.data)
        };
    }
    return getTaxon;
};
